/**
 * Pure helpers for the country overlay. Kept separate from the component so
 * they can be unit-tested without a Google Maps instance.
 */

/** "DK" → 🇩🇰 via regional indicator symbols. Returns null for non-2-letter input. */
export function isoToFlagEmoji(iso: string): string | null {
  if (!/^[A-Z]{2}$/.test(iso)) return null;
  return String.fromCodePoint(
    ...[...iso].map((c) => 0x1f1e6 + c.charCodeAt(0) - 65)
  );
}

export const easeOutCubic = (p: number) => 1 - Math.pow(1 - p, 3);
export const lerp = (a: number, b: number, t: number) => a + (b - a) * t;

/**
 * Resting (non-hovered) style. Countries with no coverage are hidden entirely
 * (like the skipped/sanctioned set) — invisible and non-interactive.
 */
export function restingStyle(
  noCoverage: boolean,
  fillColor: string,
  fillOpacity = 0.08
): google.maps.Data.StyleOptions {
  if (noCoverage) {
    return { visible: false };
  }
  return {
    strokeColor: '#9ca3af',
    strokeWeight: 0.6,
    fillColor,
    fillOpacity,
    clickable: true,
  };
}

/** Interpolated hover style at progress t (0 = resting, 1 = fully hovered) */
export function hoverStyleAt(
  t: number,
  color: string
): google.maps.Data.StyleOptions {
  return {
    strokeColor: color,
    strokeOpacity: lerp(1, 0.7, t),
    strokeWeight: lerp(0.6, 1, t),
    fillColor: color,
    fillOpacity: lerp(0.08, 0.35, t),
  };
}
